var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"ContentBox",staticClass:"is-wrapper",class:{
    'landscape': _vm.isLandscape,
    'landscape-sidebar': _vm.isLandscapeSidebar,
    'portrait': !_vm.isLandscape && !_vm.isLandscapeSidebar,
    'newsletter': _vm.isNewsletter
  },attrs:{"id":"content-wrapper"},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }